if (!customElements.get('ly-book-tooltip')) {
    customElements.define('ly-book-tooltip', class extends HTMLElement {
        delay = 60_000
        sessionDuration = 30 * 60 * 1000

        sessionStartKey = 'ly-book-tooltip-session-start'
        closedKey = 'ly-book-tooltip-closed'

        connectedCallback() {
            this.delay = this.getDurationMilliseconds('delaySeconds', 60)
            this.sessionDuration = this.getDurationMilliseconds('sessionDurationSeconds', 1800)

            this.init()
            this.bindActivityEvents()
        }

        disconnectedCallback() {
            this.unbindActivityEvents()
            clearTimeout(this._timer)
        }

        // =============================
        // 初始化（只做一次）
        // =============================
        getDurationMilliseconds = (dataKey, fallbackSeconds) => {
            const seconds = Number(this.dataset[dataKey])
            return (Number.isFinite(seconds) && seconds >= 0 ? seconds : fallbackSeconds) * 1000
        }

        init = () => {
            const now = Date.now()

            let start = +sessionStorage.getItem(this.sessionStartKey)

            if (!start) {
                start = now
                sessionStorage.setItem(this.sessionStartKey, start)
            }

            const elapsed = now - start

            if (elapsed >= this.delay) {
                this.show()
            } else {
                this.startTimer(this.delay - elapsed)
            }
        }

        // =============================
        // 启动弹窗计时（核心）
        // =============================
        startTimer = (remain = this.delay) => {
            clearTimeout(this._timer)

            this._timer = setTimeout(() => {
                this.show()
            }, remain)
        }

        // =============================
        // 用户行为 → 判断是否进入新会话
        // =============================
        bindActivityEvents = () => {
            this._activityHandler = () => {
                const now = Date.now()
                const start = +sessionStorage.getItem(this.sessionStartKey)

                // 👉 超过会话时长 → 新会话
                if (now - start > this.sessionDuration) {
                    const newStart = now

                    sessionStorage.setItem(this.sessionStartKey, newStart)
                    sessionStorage.removeItem(this.closedKey)

                    // 👉 判断是否需要立即弹
                    const elapsed = 0 // 新会话刚开始

                    if (elapsed >= this.delay) {
                        this.show()
                    } else {
                        this.startTimer(this.delay)
                    }
                }
            }

            window.addEventListener('click', this._activityHandler)
            window.addEventListener('scroll', this._activityHandler)
            window.addEventListener('keydown', this._activityHandler)
        }

        unbindActivityEvents = () => {
            window.removeEventListener('click', this._activityHandler)
            window.removeEventListener('scroll', this._activityHandler)
            window.removeEventListener('keydown', this._activityHandler)
        }

        // =============================
        // 业务逻辑
        // =============================
        show = () => {
            // 如果当前会话已经关闭过 → 不再弹
            if (sessionStorage.getItem(this.closedKey)) return

            if (this.wrapper) return

            this.render()

            requestAnimationFrame(() => {
                this.wrapper.classList.add('is-visible')
                document.documentElement.classList.add('ly-book-tooltip-visible')

                this.mask = this.wrapper.querySelector('.ly-book-tooltip-mask')
                this.mask.addEventListener('click', this.hide)

                this.closeBtn = this.wrapper.querySelector('.ly-book-tooltip-content-close-btn')
                this.closeBtn.addEventListener('click', this.hide)

                this.secondaryBtn = this.wrapper.querySelector('.ly-book-tooltip-content-btn.secondary')
                this.secondaryBtn.addEventListener('click', this.hide)
            })
        }

        render = () => {
            const wrapper = document.createElement('div')
            wrapper.className = 'ly-book-tooltip'
            this.wrapper = wrapper

            const mask = document.createElement('div')
            mask.className = 'ly-book-tooltip-mask'
            wrapper.appendChild(mask)

            const contentWrapper = document.createElement('div')
            contentWrapper.className = 'ly-book-tooltip-content-wrapper'

            const mobileSrcset = [1, 2, 3].map(i => `${this.dataset.imageMobile}&width=${i * 364} ${i}x`).join(',')
            const desktopSrcset = [1, 2].map(i => `${this.dataset.imageDesktop}&width=${i * 329} ${i}x`).join(',')

            contentWrapper.innerHTML = `
              <div class="ly-book-tooltip-content-inner-wrapper">
                <div class="ly-book-tooltip-image-wrapper">
                  <picture>
                    <source srcset="${mobileSrcset}" media="(max-width: 767px)">
                    <img src="${this.dataset.imageDesktop}&width=329" srcset="${desktopSrcset}" width="329" height="407">
                  </picture>
                </div>
                <div class="ly-book-tooltip-content">
                  <div class="ly-book-tooltip-content-inner">
                    <div class="ly-book-tooltip-content-title">${this.dataset.title}</div>
                    <div class="ly-book-tooltip-content-text">${this.dataset.text}</div>
                    <div class="ly-book-tooltip-content-btns">
                      <a href="${this.dataset.primaryLink || '#'}" class="ly-book-tooltip-content-btn primary">${this.dataset.primaryText}</a>
                      <a href="#" class="ly-book-tooltip-content-btn secondary">${this.dataset.secondaryText}</a>
                    </div>
                  </div>
                </div>

                <button class="ly-book-tooltip-content-close-btn">
                  <span class="svg-wrapper">
                    <svg width="9" height="9" viewBox="0 0 9 9">
                      <path d="M8.5 0.5013L0.500445 8.5M0.5 0.5L8.49955 8.4987" stroke="currentColor" stroke-linecap="round"/>
                    </svg>
                  </span>
                </button>
              </div>
            `

            wrapper.appendChild(contentWrapper)
            document.body.appendChild(wrapper)
        }

        hide = (evt) => {
            evt.preventDefault()
            if (!this.wrapper) return

            this.wrapper.classList.remove('is-visible')
            document.documentElement.classList.remove('ly-book-tooltip-visible')

            // 👉 本会话关闭
            sessionStorage.setItem(this.closedKey, 1)

            this.mask?.removeEventListener('click', this.hide)
            this.closeBtn?.removeEventListener('click', this.hide)
            this.secondaryBtn?.removeEventListener('click', this.hide)

            setTimeout(() => {
                this.wrapper.remove()
                this.wrapper = null
            }, 350)
        }
    })
}
